import { deref } from "kanopi-components/utils/primitives";

// Is this accurate? (Sketching out types for existing code)
type TReducedQuote = {
  state: TQuote["state"];
  coverSections: TCoverSection[];
  description: TProduct["description"];
  enabledCoverSections: TCoverSection[];
  disabledCoverSections: TCoverSection[];
};

type TCombineQuotesAndCoversFn = (
  riskProfile: TRiskProfile,
  quotes: TQuote[],
  covers: TCoverSection[]
) => TReducedQuote;

const combineQuotesAndCovers: TCombineQuotesAndCoversFn = (
  riskProfile,
  quotes,
  covers
) => {
  const enabledCoverSections = covers.filter(isCoverEnabled(riskProfile));
  const disabledCoverSections = covers.filter((c) => !isCoverEnabled(riskProfile)(c));
  return {
    ...reduceQuotes(quotes),
    state: riskProfile?.state,
    enabledCoverSections,
    disabledCoverSections,
  };
};

function reduceQuotes(quotes: TQuote[]) {
  // const softKnockout = quotes.some(q => q.periodicPrice === null)
  return {
    // TODO: This will be provided from the back-end(?)
    // periodicPrice: softKnockout ? null : quotes.reduce((p, q) => p + q.periodicPrice, 0),
    documents: reduceDocuments(quotes),
    description: reduceDescriptions(quotes),
    preTaxPremiumSum: reduceSumValues(quotes, "preTaxPremium"),
    commissionSum: reduceSumValues(quotes, "commission"),
  };
}

function reduceDocuments(quotes: TQuote[] = []) {
  return quotes.map(({ documents }) => documents).flat();
}

function reduceSumValues(quotes: TQuote[] = [], accessor: string) {
  return quotes.map((quote) => deref(quote, accessor, 0)).reduce((a, b) => a + b, 0);
}

function isCoverEnabled(riskProfile: TRiskProfile) {
  return (cover: TCoverSection) =>
    deref(riskProfile, `riskData.covers.${cover.key}.enabled`);
}

function reduceDescriptions(quotes: TQuote[] = []) {
  const descriptions = new Set(quotes.map(({ product }) => product.description));
  if (descriptions.size === 1) {
    return descriptions.values().next().value;
  }
  return "Insurance";
}

export { reduceQuotes, combineQuotesAndCovers };
